<template>
  <div class="row">
    <div class="col-lg-3 col-md-6 col-sm-6" 
      v-for="accounts in model.usersAccounts" 
      v-bind:key="accounts.id"
      :id="accounts.id">
      <balance-card type="success"
                  icon="ti-wallet"
                  
                  :title="accounts.number">
        <div class="stats" slot="footer">
          <i class='nc-icon nc-calendar-60'></i>
          {{accounts.name}} 
          <p>&nbsp;</p>
          <p-button type="danger" @click="handleDelete(accounts.id)" block round>
            Unlink Account
          </p-button>
        </div>
      </balance-card>
    </div>
    <div class="col-lg-3 col-md-6 col-sm-6" >
        <balance-card type="success"
                    icon="ti-wallet"
                    
                    title="Acc: ***123">
          <div class="stats" slot="footer">
            <router-link :to="{ name: 'Link Account'}">
              <span class="ti-plus" type="primary" round>
                Add Account
              </span>
            </router-link>
          </div>
        </balance-card>
      </div>
  </div>
</template>
<script>
  import Card from 'src/components/UIComponents/Cards/Card.vue'
  import BalanceCard from 'src/components/UIComponents/Cards/BalanceCard';

  export default {

    components: {
      BalanceCard,
      Card
    },

    data () {
      return {
        model: {
          usersAccounts: [],
        }
       }
    },
    methods: {
      handleDelete (index) {

        this.$http.delete("/accounts/" + index)
        .then(response => {

          if (response.status == 204) {
            document.getElementById(index).style.display = 'none'
          }
        })
        .catch(err => console.error(err));
      },
      
      getAccounts () {
        this.$http.get('/accounts')
        .then(response => {

          response.data.map(function (e) {
            
            e.name = e.name.replace('First City Monument Bank', 'FCMB')
            e.name = e.name.replace('Guaranty Trust Bank', 'GTB')
            e.name = e.name.replace('VFD Microfinance Bank Limited', 'VFD')
           
            e.name = e.name.replace('United Bank For Africa', 'UBA')
            e.name = e.name.replace('Microfinance Bank', 'MFB')

            if (e.name.substring(e.name.length - 5) == ' Bank') {
              e.name= e.name.replace(' Bank', '')
            }
          });

          this.model.usersAccounts = response.data

        })
        .catch(err => console.error(err));
		  }
     
    },
    
    async mounted () {
      this.getAccounts () 
    }
  }
</script>
<style lang="scss">
.card-stats .card-body .numbers { text-align: left !important; }
</style>
